export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Updated to accept is247Filtered parameter for Google search
export const fetchPharmacies = async (query, is247Filtered = false) => {
  try {
    let url = `${BASE_URL}/pharmacy/search?query=${encodeURIComponent(query)}`;
    if (is247Filtered) {
      url += `&googleOpen24Hours=true`;
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to fetch pharmacy data from Google API via backend");
    return await res.json();
  } catch (error) {
    console.error("Fetch error (Google API via backend):", error);
    return { results: [] }; // Return structure expected by PharmacyLocator
  }
};

export const fetchPharmaciesByLocation = async (lat, lng) => {
  try {
    const res = await fetch(
      `${BASE_URL}/pharmacy/nearby?lat=${lat}&lng=${lng}`
    );
    return await res.json();
  } catch (err) {
    console.error("Location fetch error:", err);
    return null;
  }
};

// Updated to accept is247Filtered parameter for local DB search
export const fetchLocalPharmacies = async (query, is247Filtered = false) => {
  try {
    let url = `${BASE_URL}/pharmacy/local?query=${encodeURIComponent(query)}`;
    if (is247Filtered) {
      url += `&filterOpen24Hours=true`;
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error("Local API response not ok for fetching local pharmacies");
    return await res.json();
  } catch (error) {
    console.error("Local search error (fetching local pharmacies):", error);
    return [];
  }
};

export const fetchAllPharmacies = async () => {
  try {
    const response = await fetch(`${BASE_URL}/pharmacy/admin/all`);
    return await response.json();
  } catch (err) {
    console.error("Error fetching pharmacies:", err);
    return [];
  }
};

export const updatePharmacyStatus = async (id, status) => {
  try {
    const res = await fetch(`${BASE_URL}/pharmacy/admin/status/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });
    return await res.json();
  } catch (err) {
    console.error("Failed to update status:", err);
    return null;
  }
};



export const updatePharmacyDetails = async (updatedData) => {
  try {
    const response = await fetch(`${BASE_URL}/pharmacy/admin/update/${updatedData.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });

    return await response.json();
  } catch (error) {
    console.error("Error updating pharmacy:", error);
    return { success: false, error };
  }
};
